import { Team } from '../models/team.model';

export class AddTeams {
    static readonly type = '[Team] AddTeams';

    constructor(public payload: Team[]) {}
}
